<template>
	<div class="mock-exam-entry">正在进入模拟考试...</div>
</template>

<script>
import { getExercisesId } from "@/api/user";

const CATEGORY_ID = 119;
const SUBJECT = 0;
const APP_NO = "APP02";
const PRACTICE_WAY = 3;

export default {
	name: "vipmockexam",
	data() {
		return {
			historyCity: JSON.parse(localStorage.getItem("historyCity")) === null ? [{ "": "", cityName: "全国" }] : JSON.parse(localStorage.getItem("historyCity"))
		};
	},
	created() {
		this.initMockExam();
	},
	methods: {
		initMockExam() {
			sessionStorage.setItem("appno", APP_NO);
			sessionStorage.setItem("categoryId", String(CATEGORY_ID));
			sessionStorage.setItem("subject", String(SUBJECT));
			this.$store.dispatch("setAppno", "2");

			getExercisesId({
				categoryId: CATEGORY_ID,
				subject: SUBJECT,
				cityCode: this.historyCity[0].cityCode,
				practiceWay: PRACTICE_WAY
			}).then((data) => {
				if (data && data.ExercisesId && data.ExercisesId.length > 0) {
					sessionStorage.setItem("exam", JSON.stringify(data));
					this.$router.replace({
						path: "/viporder",
						query: { title: "模拟考试", subject: SUBJECT }
					});
					return;
				}
				this.showEmptyTip();
			}).catch(() => {
				this.showEmptyTip();
			});
		},
		showEmptyTip() {
			this.$dialog.alert({
				message: "题库正在建设中，敬请期待",
				theme: "round-button",
				width: 290
			});
		}
	}
};
</script>

<style scoped>
.mock-exam-entry {
	padding: 24px;
	text-align: center;
	color: #666;
	font-size: 14px;
}
</style>
